webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	__webpack_require__(6);
	
	__webpack_require__(8);
	
	__webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
		_angular2.default.module('ahsv', ['gallery', 'header', 'icon', 'location', 'video']);
	})();

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('gallery', ['ngDialog']).directive('gallery', gallery).directive('galleryToggle', galleryToggle).controller('galleryDialogCtrl', galleryDialogCtrl);
	
	
	gallery.$inject = [];
	
	function gallery($scope) {
		var directive = {
			restrict: 'A',
			scope: {},
			controller: controller,
			link: link,
			transclude: true
		};
	
		controller.$inject = ['$scope'];
	
		return directive;
	
		function controller($scope) {
			$scope.items = [];
	
			this.addItem = function (item) {
				$scope.items.push(item);
			};
		}
	
		function link(scope, elem, attr, ctrl, transclude) {
			transclude(scope, function (clone) {
				elem.append(clone);
			});
		}
	}
	
	galleryToggle.$inject = ['ngDialog'];
	
	function galleryToggle(ngDialog) {
		var directive = {
			link: link,
			restrict: 'A',
			require: '^gallery',
			scope: true
		};
		return directive;
	
		function link(scope, element, attrs, galleryCtrl) {
			element.on('click', function (e) {
				e.preventDefault();
	
				ngDialog.open({
					showClose: false,
					template: wp.template_directory_uri + '/templates/gallery.html',
					className: 'ngdialog-theme-custom',
					controller: 'galleryDialogCtrl',
					data: {
						index: parseInt(attrs.galleryIndex, 10),
						items: scope.items
					}
				});
			});
	
			galleryCtrl.addItem(attrs.galleryToggle);
		}
	}
	
	galleryDialogCtrl.$inject = ['$scope'];
	
	function galleryDialogCtrl($scope) {
		$scope.active = _angular2.default.copy($scope.ngDialogData.index);
		$scope.items = _angular2.default.copy($scope.ngDialogData.items);
	
		$scope.next = function () {
			if ($scope.active === $scope.items.length - 1) {
				return $scope.active = 0;
			}
	
			return $scope.active++;
		};
	
		$scope.prev = function () {
			if ($scope.active === 0) {
				return $scope.active = $scope.items.length - 1;
			}
	
			return $scope.active--;
		};
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _headroom = __webpack_require__(5);
	
	var _headroom2 = _interopRequireDefault(_headroom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('header', []).directive('header', header);
	
	
	header.$inject = [];
	
	function header() {
		var directive = {
			link: link,
			restrict: 'A',
			scope: {}
		};
		return directive;
	
		function link(scope, elem) {
			var options = {
				offset: elem[0].clientHeight,
				classes: {
					// when element is initialised
					initial: 'header',
					// when scrolling up
					pinned: 'header--pinned',
					// when scrolling down
					unpinned: 'header--unpinned',
					// when above offset
					top: 'header--top',
					// when below offset
					notTop: 'header--not-top',
					// when at bottom of scoll area
					bottom: 'header--bottom',
					// when not at bottom of scroll area
					notBottom: 'header--not-bottom'
				}
			};
			var headroom = new _headroom2.default(elem[0], options);
			headroom.init();
		}
	}

/***/ },
/* 5 */,
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _svgInjector = __webpack_require__(7);
	
	var _svgInjector2 = _interopRequireDefault(_svgInjector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('icon', []).directive('icon', icon);
	
	
	function icon() {
		var directive = {
			link: link,
			restrict: 'E',
			template: '<img class="icon-svg" ref="image" alt="" />',
			scope: {}
		};
		return directive;
	
		function link(scope, element, attrs) {
			if (!attrs.hasOwnProperty('src')) {
				return null;
			}
	
			var src = attrs.src;
			var img = element[0].querySelector('.icon-svg');
			// Set the image src attribute
			img.setAttribute('src', wp.template_directory_uri + src);
			// Call the SVG injector
			(0, _svgInjector2.default)(element[0].querySelector('.icon-svg'), null, function () {
				// Remove all the "fill" attribute
				var filledElements = element[0].querySelectorAll('[fill]');
				if (filledElements) {
					for (var i = 0; i < filledElements.length; i++) {
						if (filledElements[i].getAttribute('fill') !== 'none' && filledElements[i].getAttribute('fill') !== 'currentColor') {
							filledElements[i].removeAttribute('fill');
						}
					}
				}
			});
		}
	}

/***/ },
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('location', ['ngMap']).directive('location', location);
	
	
	location.$inject = [];
	
	function location() {
		var directive = {
			link: link,
			restrict: 'A',
			scope: true
		};
		return directive;
	
		function link(scope) {
			scope.marker = {
				url: wp.template_directory_uri + '/public/assets/images/icons/map-pin.svg',
				scaledSize: [45, 52.5],
				origin: [0, 0],
				anchor: [22.5, 52.5]
			};
		}
	}

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('video', ['ngDialog', 'ngSanitize']).directive('video', video).controller('videoCtrl', videoCtrl);
	
	
	video.$inject = ['ngDialog'];
	
	function video(ngDialog) {
		var directive = {
			restrict: 'A',
			scope: {},
			link: link
		};
	
		return directive;
	
		function link(scope, elem, attrs) {
			elem.on('click', function (e) {
				e.preventDefault();
	
				ngDialog.open({
					showClose: false,
					template: wp.template_directory_uri + '/templates/video.html',
					className: 'ngdialog-theme-custom',
					controller: 'videoCtrl',
					data: {
						video: attrs.videoUrl,
						type: attrs.videoType
					}
				});
			});
		}
	}
	
	videoCtrl.$inject = ['$scope', '$sce'];
	
	function videoCtrl($scope, $sce) {
		$scope.trustSrc = function (src) {
			return $sce.trustAsResourceUrl(src);
		};
	}

/***/ }
]);


/** WEBPACK FOOTER **
 ** index.js
 **/